// back to top js===========

$(document).ready(function(){
    $(window).scroll(function(){
        if ($(this).scrollTop() > 100) {
            $('.back_to_top').fadeIn();
        } else {
            $('.back_to_top').fadeOut();
        }
    });
    $('.back_to_top').click(function(){
        $('html, body').animate({scrollTop : 0});
    });
});


// footer accordion js============

$(document).on('click', '.a_footer_accordion_btn', function(){

    var parent = $(this).closest('.a_footer_accordion_item');
    var content = parent.find('.a_footer_accordion_content');

    $('.a_footer_accordion_item')
    .not(parent)
    .removeClass('active')
    .find('.a_footer_accordion_content')
    .stop(true,true)
    .slideUp(300);

    parent.toggleClass('active');
    content.stop(true,true).slideToggle(300);

});


// footer mobile menu accordion js==============

$(document).ready(function () {

  $('.a_footer_label').on('click', function () {

    if ($(window).width() <= 575) {

      var parent = $(this).closest('.a_footer_menu_col');
      var content = parent.find('ul');

      $('.a_footer_menu_col')
        .not(parent)
        .removeClass('active')
        .find('ul')
        .slideUp(300);

      parent.toggleClass('active');
      content.stop(true, true).slideToggle(300);
    }

  });

});


// product page accorion ==============

$(document).ready(function () {

  $('.accordion-header').on('click', function () {

    var parent = $(this).closest('.product__accordion');
    var content = $(this).next('.accordion__content');

    $('.product__accordion')
      .not(parent)
      .removeClass('active')
      .find('.accordion__content')
      .slideUp(300);

    parent.toggleClass('active');
    content.stop(true, true).slideToggle(300);

  });

});